import { AxiosResponse } from "axios";
import BaseAPI from "../api";
import { pagination_list } from "../type";

const path: string = "/edpex-mission";

export type listType = {
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
};

export interface edpex_mission_dropdown_type extends pagination_list {
  keyword?: string;
}

export class edpexMissionAPI extends BaseAPI {
  static getEdpexMissionList(query: listType): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }

  static createEdpexMission(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static getEdpexMissionById(id: number): Promise<any> {
    return this.api.get(`/${id}`);
  }

  static updateEdpexMission(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteEdpexMission(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
  static dropdown(params: edpex_mission_dropdown_type): Promise<AxiosResponse> {
    return this.api.get(`${path}/dropdown`, { params })
  }
}
